// Unsaved-change protection: while `dirty`, the browser asks before the tab closes or reloads.
// Closing the tab is the way typed work actually gets lost; in-app navigation is a router concern.

import { useEffect } from 'react';

export function useUnsavedWarning(dirty) {
  useEffect(() => {
    if (!dirty) return undefined;
    const warn = (event) => {
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [dirty]);
}
